<div *ngFor="let team of team">
  {{ team?.firstName }} {{ team?.lastName }} ({{
    (team?.permissions)[0]?.role
  }})
</div>

<div class="example-container">
  <mat-table #table [dataSource]="dataSource">
    <ng-container cdkColumnDef="firstName">
      <mat-header-cell *cdkHeaderCellDef>First Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row">{{ row?.firstName }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="lastName">
      <mat-header-cell *cdkHeaderCellDef>Last Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row">{{ row?.lastName }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="email">
      <mat-header-cell *cdkHeaderCellDef>Email</mat-header-cell>
      <mat-cell *cdkCellDef="let row">{{ row?.email }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="role">
      <mat-header-cell *cdkHeaderCellDef>Role</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        {{ (row?.permissions)[0]?.role | role }}
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="action">
      <mat-header-cell *cdkHeaderCellDef>Action</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <button mat-button color="warn" (click)="removeMember.emit(row)">
          Remove
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
